import { CommentService } from './../core/comment.service';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import { LinkFileListService } from './services/link-file-list.service';
import { LinkConsumeComponent } from './link-consume/link-consume.component';
import { ApplinkConsumeComponent } from './applink-consume/applink-consume.component';
import { LinkFileListComponent } from './link-file-list/link-file-list.component';
import { LinkErrorComponent } from './link-error/link-error.component';
import {
    NgbPaginationModule,
    NgbDropdownModule,
    NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LinkConsumePasswordComponent } from './link-consume-password/link-consume-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogReportLinkComponent } from './dialog-report-link/dialog-report-link.component';
import { DialogLinkZipComponent } from './dialog-link-zip/dialog-link-zip.component';
import { Title } from '@angular/platform-browser';
import { LinkConsumeRoutingModule } from './link-consume-routing.module';
import { LayoutModule } from '../layout/layout.module';
import { FileModule } from '../file/file.module';
@NgModule({
    imports: [
        LinkConsumeRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbPaginationModule,
        NgbDropdownModule,
        NgbProgressbarModule,
        CommonModule,
        SharedModule,
        LayoutModule,
        FileModule
    ],
    providers: [LinkFileListService, CommentService, Title],
    declarations: [
        LinkConsumeComponent,
        ApplinkConsumeComponent,
        LinkFileListComponent,
        LinkErrorComponent,
        LinkConsumePasswordComponent,
        DialogReportLinkComponent,
        DialogLinkZipComponent,
    ],
    entryComponents: [
        DialogReportLinkComponent,
        DialogLinkZipComponent,
        LinkConsumeComponent,
        ApplinkConsumeComponent,
    ]
})
export class LinkConsumeModule {}
